import React__default from 'react';
import { CardActionArea, CardMedia, CardContent, Box } from '@mui/material';
import clsx from 'clsx';
import StyledKPortalCard, { classes } from './index.styled.js';

/**
 * Portal card component
 */
var KPortalCard = function (_a) {
    var className = _a.className, style = _a.style, children = _a.children, title = _a.title, previewTitle = _a.previewTitle, previewUrl = _a.previewUrl, actions = _a.actions, href = _a.href, sx = _a.sx;
    return (React__default.createElement(StyledKPortalCard, { className: clsx("KPortalCard", className), style: style, "data-testid": "portal-card", sx: sx },
        React__default.createElement(CardActionArea, { className: classes.actionArea, href: href },
            React__default.createElement(CardMedia, { className: classes.image, image: previewUrl, title: previewTitle }),
            React__default.createElement(CardContent, { className: classes.content },
                React__default.createElement(Box, { className: classes.contentHeader },
                    React__default.createElement(Box, null, title),
                    React__default.createElement(Box, null, actions)),
                children))));
};

export { KPortalCard as default };
//# sourceMappingURL=index.js.map
